'use es6';

import InitialMessage from 'conversations-visitor-message-history/initial-message/InitialMessage';
import { connect } from 'react-redux';
import { isStarted } from '../../../threads/operators/isStarted';
import { getChatHeadingConfig } from '../../../chat-heading-config/selectors/getChatHeadingConfig';
import { getSendFromResponders } from '../../../responders/selectors/getSendFromResponders';
import { publishVisitorMessage } from '../../../pubsub/actions/publishVisitorMessage';
import { hasUnansweredQuickReplyMessage } from '../../../selectors/chatSelectors';
import { getSelectedThread } from '../../../selected-thread/selectors/getSelectedThread';
import { getIsMobile } from '../../../selectors/getIsMobile';
const mapStateToProps = state => {
  const selectedThread = getSelectedThread(state);
  return {
    chatHeadingConfig: getChatHeadingConfig(state),
    sendFromResponders: getSendFromResponders(state),
    hasUnansweredQuickReplyMessage: hasUnansweredQuickReplyMessage(state, {
      thread: selectedThread
    }),
    isThreadStarted: isStarted(selectedThread),
    mobile: getIsMobile(state)
  };
};
const mapDispatchToProps = {
  publishMessage: publishVisitorMessage
};
export default connect(mapStateToProps, mapDispatchToProps)(InitialMessage);